import React from "react";
/* FIXED: Import createRoot from 'react-dom/client' */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./Debug/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

// Function to hide the HTML loader smoothly
const hideHTMLLoader = () => {
  const loader = document.getElementById("startingLoader");
  if (loader) {
    if (window.loadingComplete) {
      loader.style.transition = "opacity 0.3s ease-out";
      loader.style.opacity = "0";
      setTimeout(() => {
        loader.style.display = "none";
      }, 300);
    } else {
      setTimeout(hideHTMLLoader, 100);
    }
  }
};

const container = document.getElementById("root");
/* FIXED: Initialize the root */
const root = createRoot(container);

// Render the React app
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

/* FIXED: Since createRoot doesn't have a callback, 
   we trigger the loader check immediately after calling render */
setTimeout(() => {
  hideHTMLLoader();
}, 100);

// Service worker and web vitals
serviceWorkerRegistration.unregister();
reportWebVitals();
